import React from 'react'
import { Container, ContainerProps, Stack } from '@mantine/core'
import styles from './layout.module.css'
import GeneralAiFab from '@/components/shared/GeneralAiFab'

interface ResponsiveLayoutProps extends ContainerProps {
    children: React.ReactNode
    layout?: 'mobile' | 'desktop'
    adjustForDesktop?: boolean
    /** When false with adjustForDesktop, omit horizontal padding on the inner stack (focused-flow pages pad via their header). */
    padContent?: boolean
    /** When true, omit the default top margin so focused-flow headers control top inset. */
    flushTop?: boolean
    showGeneralAiFab?: boolean
    generalAiFabIngress?: 'fab_store' | 'fab_account' | 'fab_care_plan' | 'fab_lab_results'
}

const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({
    children,
    layout,
    adjustForDesktop,
    padContent = true,
    flushTop = false,
    showGeneralAiFab,
    generalAiFabIngress = 'fab_store',
    ...rest
}: ResponsiveLayoutProps) => {
    return (
        <>
            <Container
                size={layout === 'desktop' ? 'lg' : 400}
                style={{ width: '100%' }}
                className={`${styles.responsiveContainer}${flushTop ? ` ${styles.responsiveContainerFlushTop}` : ''}`}
                {...rest}
            >
                {adjustForDesktop ? renderAdjustedLayout() : renderStandardLayout()}
            </Container>
            {showGeneralAiFab && <GeneralAiFab ingress={generalAiFabIngress} />}
        </>
    )

    function renderStandardLayout() {
        return children
    }

    // Ideally this should be our standard but unsure of how it will affect other pages
    // so requiring the adjustForDesktop prop for now
    function renderAdjustedLayout() {
        return (
            <Stack
                align={'center'}
                mx={'calc(50% - 50vw)'}
                flex={1}
                style={{
                    overflowX: 'hidden',
                }}
            >
                <Stack px={padContent ? { base: 24, sm: 0 } : 0} w={{ base: '100dvw', sm: '50vw' }}>
                    {children}
                </Stack>
            </Stack>
        )
    }
}

export default ResponsiveLayout
